import { GridPostParams } from "common/models/utility-models/list-utility.model";

export class CreditReportsGridPostParams extends GridPostParams {
    reportTypeFlag: number = 2;
    search_keyword: '';
    region_search: string = '';
    batch_search: any = '';
    branch_search: any = '';
    state_search: any = '';
    gender_search: string = ''
    status_search: any = '';
}
